export const applyConstants = {
  LOAD: 'apply/LOAD',
  LOAD_SUCCESS: 'apply/LOAD_SUCCESS',
  LOAD_FAIL: 'apply/LOAD_FAIL',
  GET_VERTICALIZATION_QUESTIONS: 'apply/GET_VERTICALIZATION_QUESTIONS',
};
